import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

interface ScottBrandIconProps extends IconWrapperProps {
  variant?: "light" | "dark";
}

function ScottBrandSvg(props: {
  variant?: "light" | "dark";
  className?: string;
}) {
  const variant = props.variant || "light";
  const fillColor = variant === "light" ? "currentColor" : "#44403C";

  return (
    <svg
      className={props.className}
      fill="none"
      role="img"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>SCOTT</title>
      <path
        d="M18.0633 21.2521C17.8719 20.9107 17.7587 20.5222 17.7587 20.1052C17.7587 19.6883 17.8649 19.3173 18.048 18.9799L21.0176 13.9917C21.0176 13.9917 21.1923 13.6018 21.761 13.228C22.3312 12.8543 23.002 12.8745 23.002 12.8745L30.3708 12.8772L34.4863 6H19.7822C18.4686 6.00675 17.3171 6.66249 16.6519 7.65285L11.1767 16.8576C10.4304 18.0759 10 19.494 10 21.0106C10 22.5272 10.4234 23.9237 11.1571 25.134V25.1407L17.0879 35.0052L20.6766 29.0576C21.2677 28.0079 21.2845 26.7369 20.7227 25.675L18.0633 21.2521Z"
        fill={fillColor}
      />
      <path
        d="M29.4659 26.7472C29.656 27.0886 29.7692 27.4812 29.7692 27.8954C29.7692 28.3097 29.663 28.6834 29.4799 29.0194L26.5117 34.0103C26.5117 34.0103 26.3356 34.3989 25.7654 34.7727C25.1967 35.1451 24.5245 35.1262 24.5245 35.1262L17.1571 35.1221L13.043 41.9993H27.747C29.0606 41.9926 30.2122 41.3355 30.8787 40.3465L36.354 31.1404C37.0988 29.922 37.5293 28.5067 37.5293 26.9874C37.5293 25.4681 37.1058 24.0757 36.3708 22.864V22.8586L30.4413 12.9941L26.8527 18.9417C26.2615 19.9901 26.2448 21.2624 26.8065 22.3243L29.4659 26.7459V26.7472Z"
        fill={fillColor}
      />
    </svg>
  );
}

export function IconScottBrand(props: ScottBrandIconProps) {
  return (
    <IconWrapper {...props}>
      <ScottBrandSvg className={props.className} variant={props.variant} />
    </IconWrapper>
  );
}
